import { isSet } from '../utils/isSet';
import { TabList } from './TabList';
import { Dropdown } from "./Dropdown";
import { ValidationEngine } from './HireValidationEngine';
import v8n from 'v8n';

class HireDelivery {
    constructor(root, PlacesAPI, AutocompleteSessionToken, AutocompleteSuggestion){
        this.root = root;
        this.PlacesAPI = PlacesAPI

        this.selectedDeliveryType = this.root.querySelector('[role="tab"][aria-selected="true"]').dataset.type;

        this.deliveryTypeInput = this.root.querySelector('#hire-journey-input--delivery');
        this.deliveryAddressInput = this.root.querySelector('#hire-journey-input--address');

        this.locateButton = this.root.querySelector('#delivery-collect-locate');
        this.dataUrl = this.root.getAttribute("data-fetch-url");
        this.depotLocationTemplate = document.querySelector('#depot-location--template');

        this.addressLookupElementContainer = this.root.querySelector('#hire-journey-widget__address-lookup');
        this.addressLookupSearchInput = this.addressLookupElementContainer.querySelector('#hire-journey-input--address-search');
        this.addressLookupClearButton = this.addressLookupElementContainer.querySelector('.hire-journey-widget__address-clear--js');

        this.addressLoookupResults = this.addressLookupElementContainer.querySelector('.results-inner');
        
        this.searchTimeout = 0;
        this.previousSearchString = '';

        this.deliveryAddressFormatted = '';

        this.deliveryAddressComponentLabels = [
            "subpremise",
            "street_number",
            "route",
            "locality",
            "postal_town",
            "administrative_area_level_2",
            "administrative_area_level_1",
            "country",
            "postal_code",
        ];

        this.deliveryAddressComponents = [];

        this.placesRequest = {
            input: "",
            origin: { lat: 55.786059, lng: -3.981506 },
            language: "en-GB",
            region: "gb",
            includedRegionCodes: ["gb"]
        }

       

        this.init();
    }

    /**
     * Gets things started
     */
    init(){
        const handleTabChangeHandler = this.#handleTabChange.bind(this);

        this.TabList = new TabList(
            this.root, 
            {
                onChange: (obj, e) => handleTabChangeHandler(obj, e)
            }
        );

        this.Dropdown = new Dropdown(
            this.addressLookupElementContainer,
            {
                openOnTriggerClick: false,
                openOnArrowKeydown: false,
                setFocusOnOpen: false
            }
        );

        this.locateButton.addEventListener(
            'click', 
            this.handleLocateButtonClick.bind(this), 
            false
        );

        this.addressLookupSearchInput.addEventListener(
            'keyup',
            this.handleAddressInputKeyup.bind(this),
            false
        );

        this.addressLookupSearchInput.addEventListener(
            'click',
            this.handleAddressInputClick.bind(this),
            false
        );

        this.addressLookupClearButton.addEventListener(
            'click',
            this.clearAddressInput.bind(this),
            false
        )

        this.loadMapLocations(this.dataUrl);

        const addressFieldValidation = v8n()
            .string()
            .minLength(1);
    }


    /**
     * Generate token and initial request
     */
    async placeInit(){
        this.token = new google.maps.places.AutocompleteSessionToken();
        this.placesRequest = this.refreshToken(this.placesRequest);
    }

    /**
     * Helper for refreshing the google autocomplete token
     * @param {*} request 
     * @returns 
     */
    async refreshToken(request) {
        this.token = new google.maps.places.AutocompleteSessionToken();
        request.sessionToken = this.token;
        this.placesRequest = request;
        return request;
    }

    /**
     * Handles Input Keyup events
     * @returns 
     */
    handleAddressInputKeyup(){
        if(!this.hasChanged(this.addressLookupSearchInput.value)){
            return;
        }

        this.previousSearchString = this.addressLookupSearchInput.value;

        clearTimeout(this.searchTimeout);

        if(this.addressLookupSearchInput.value === ''){
            this.Dropdown.closeDropdown();
            this.addressLoookupResults.replaceChildren();
            return;
        } else{
            if(this.Dropdown.isOpen === false) this.Dropdown.openDropdown();
        }

        this.searchTimeout = setTimeout(
            this.makeAutocompleteRequest(this.addressLookupSearchInput.value),
            700
        );
    }



    /**
     * Handles all click events on the search input
     * @param {*} e The event that triggered this method
     */
    handleAddressInputClick(e){
        if(this.addressLookupSearchInput.value === '') return;

        this.Dropdown.openDropdown();
    }


    
    /**
     * Make a request to Google autocomplete
     * @param {*} input 
     */
    async makeAutocompleteRequest(input) {
        this.placesRequest.input = input;

        this.addressResultsTempStore = [];

        const { suggestions } =
        await google.maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions(
            this.placesRequest,
        );
        
        for (const suggestion of suggestions) {
            this.fetchPrediction(suggestion.placePrediction);
        }

        this.addressLoookupResults.replaceChildren(...this.addressResultsTempStore);
    }

    /**
     * 
     * @param {*} placePrediction 
     */
    async fetchPrediction(placePrediction){
        const suggestionButton = document.createElement("button");
        suggestionButton.textContent = placePrediction.text.toString();
        suggestionButton.setAttribute('data-address', placePrediction.text.toString());

        const handler = (e) => this.handleAddressSuggestionButtonClick(placePrediction.toPlace());
        suggestionButton.addEventListener("click", handler);

        this.addressResultsTempStore.push(suggestionButton);
    }

    /**
     * 
     * @param {*} placePrediction 
     */
    async handleAddressSuggestionButtonClick(placePrediction){
        await placePrediction.fetchFields({
            fields: ["formattedAddress", "addressComponents"],
        });

        this.deliveryAddressFormatted = placePrediction.formattedAddress;
        this.deliveryAddressComponents = placePrediction.addressComponents;

        this.deliveryAddressComponentLookup = {};

        for (const component of this.deliveryAddressComponents) {
            for (const type of component.types) {
                this.deliveryAddressComponentLookup[type] = component.longText;
            }
        }

        this.handleAddressInputAssignment();
        this.handleAddressSelectionDisplay();
        this.addressLookupSearchInput.value = '';
        this.Dropdown.closeDropdown();

        this.refreshToken(this.placesRequest);
    }


    /**
     * 
     */
    handleAddressInputAssignment(){
        this.clearAddressInput();

        const addressInputFormatted = document.getElementById('hire-journey-input--address__formatted');
        addressInputFormatted.value = this.deliveryAddressFormatted;

        this.deliveryAddressComponentLabels.forEach((componentPartLabel) => {
            const addressComponentInput = document.getElementById('hire-journey-input--address__' + componentPartLabel);

            if(this.deliveryAddressComponentLookup && isSet(this.deliveryAddressComponentLookup[componentPartLabel]) && this.deliveryAddressComponentLookup[componentPartLabel] !== ''){
                addressComponentInput.value = this.deliveryAddressComponentLookup[componentPartLabel];
            }
        });
    }


    /**
     * 
     * @param {*} e 
     */
    clearAddressInput(e = null){
        const addressInputFormatted = document.getElementById('hire-journey-input--address__formatted');
        addressInputFormatted.value = '';

        this.deliveryAddressComponentLabels.forEach((componentPartLabel) => {
            const addressComponentInput = document.getElementById('hire-journey-input--address__' + componentPartLabel);

            if(isSet(addressComponentInput)) addressComponentInput.value = '';
        });

        this.addressLookupSearchInput.setAttribute('placeholder', 'Search for your address');

        if(e && e.currentTarget === this.addressLookupClearButton){
            this.addressLookupClearButton.classList.add('is-hidden');
            this.addressLookupSearchInput.value = '';
            this.Dropdown.closeDropdown();

        }
    }


    /**
     * 
     */
    handleAddressSelectionDisplay(){
        this.addressLookupSearchInput.classList.add('has-selection');
        this.addressLookupSearchInput.setAttribute('placeholder', this.deliveryAddressFormatted);
        this.addressLookupClearButton.classList.remove('is-hidden');
    }

    handleAddressValidation(){

    }


    /**
     * Fetch the depot locations from JSON URL
     * @param {*} url 
     */
    async loadMapLocations(url){
        const jsonres = await fetch(url);
        const jsonList = await jsonres.json();
        this.jsonList = jsonList;
    }

    /**
     * Handles when a the TabList changes
     * @param {*} obj 
     * @param {*} e 
     * @returns 
     */
    #handleTabChange(obj, e){
        if(!isSet(obj.selected.dataset.type) || obj.selected.dataset.type === this.selectedDeliveryType) return;

        this.selectedDeliveryType = obj.selected.dataset.type;
    }

    /**
     * Handles the click event on the locate button
     */
    async handleLocateButtonClick(){
        if(!isSet(this.closestDepot)){
            const userLocation = await this.getUserLocation();
            this.userLocation = userLocation;

            this.findClosestDepotLocation(userLocation);
        }

        this.buildClosestDepotCard(this.closestDepot);
    }

    /**
     * Make initial request for the users location
     * @returns 
     */
    async getUserLocation() {
        const pos = await new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(resolve, reject);
            this.locateButton.querySelector('span').textContent = 'Finding Your Closest Depot...';
            this.locateButton.setAttribute('disabled', 'true');
        });
      
        return {
            lng: pos.coords.longitude,
            lat: pos.coords.latitude,
        };
    }


    /**
     * Calculates distance between coordinates
     * @param {*} userLat 
     * @param {*} userLng 
     * @param {*} depotLat 
     * @param {*} depotLng 
     * @param {*} unit 
     * @returns 
     */
    getDistance(userLat, userLng, depotLat, depotLng, unit) {
        if ((userLat == depotLat) && (userLng == depotLng)) {
            return 0;
        } else {
            const radUserlat = Math.PI * userLat/180;
            const radDepotLat = Math.PI * depotLat/180;
            const theta = userLng-depotLng;
            const radTheta = Math.PI * theta/180;
            let dist = Math.sin(radUserlat) * Math.sin(radDepotLat) + Math.cos(radUserlat) * Math.cos(radDepotLat) * Math.cos(radTheta);
            
            if (dist > 1) {
                dist = 1;
            }

            dist = Math.acos(dist);
            dist = dist * 180/Math.PI;
            dist = dist * 60 * 1.1515;

            if (unit=="K") { 
                dist = dist * 1.609344 
            }

            if (unit=="N") { 
                dist = dist * 0.8684 
            }

            return dist;
        }
    }

    /**
     * Searches for the closest depot to the user
     * @param {*} userLocation 
     */
    findClosestDepotLocation(userLocation){
        const depots = this.jsonList;
        const user = userLocation;
        let closestDepot = "";
        let closestDepotDistance = ""

        for (let i = 0; i < depots.length; i++) {
            let depot = depots[i];

            let userLat = user.lat;
            let userLng = user.lng;
            let depotLat = depot.lat;
            let depotLng = depot.lng;

            let distance = this.getDistance(userLat, userLng, depotLat, depotLng);

            if(closestDepot == "" || closestDepotDistance == ""){
                closestDepot = depot;
                closestDepotDistance = distance;
                continue;
            }

            if(distance < closestDepotDistance){
                closestDepot = depot;
                closestDepotDistance = distance;
            }
        }

        this.closestDepot = closestDepot;
    }


    /**
     * Builds a depot card element
     * @param {*} closestDepot 
     * @returns 
     */
    buildClosestDepotCard(closestDepot){
        let depotLocationElm = this.depotLocationTemplate.content.cloneNode(true).children[0];

        if(!isSet(closestDepot.slug)) return;

        let depotLocationElmTrigger = depotLocationElm.querySelector('.depot-location__map-trigger--js');
        let depotLocationElmTitle = depotLocationElm.querySelector('.depot-location__title');
        let depotLocationElmAddress = depotLocationElm.querySelector('.depot-location__address');
        let depotLocationElmPhone = depotLocationElm.querySelector('.depot-location__phone');

        depotLocationElmTrigger.remove();

        depotLocationElm.dataset.slug = location.slug;

        if(isSet(closestDepot.title)){
            depotLocationElmTitle.textContent = closestDepot.title;
        } else{
            depotLocationElmTitle.remove();
        }

        if(isSet(closestDepot.address)){
            depotLocationElmAddress.textContent = closestDepot.address;
        } else{
            depotLocationElmAddress.remove();
        }

        if(isSet(closestDepot.tel)){
            depotLocationElmPhone.textContent = closestDepot.tel;
        } else{
            depotLocationElmPhone.remove();
        }

        this.locateButton.insertAdjacentHTML("beforebegin", "<p><strong>Your closest depot is:</strong></p>");

        this.locateButton.insertAdjacentHTML("afterend", "<a href='#' class='button button--primary' target='_blank'><span>View All Our Depots</span></a>");

        this.locateButton.replaceWith(depotLocationElm);
    }

    /**
     * Checks if the passed string is different when compared with the previously stored search string this.previousSearchString
     * @param  {String}  value  The search query string that we want to check that has changed
     */
    hasChanged(value){
        if(value == this.previousSearchString){
            return false;
        }

        return true;
    }
}

exports.HireDelivery = HireDelivery